/*
 * Parcours d'adhésion, du formulaire à l'espace membre (textes « join.steps.* », fr/nl/en).
 * Utilisé par la page « Nous rejoindre » (tous les profils) et la page Particuliers (version particuliers).
 */
import type { TFunction } from 'i18next';
import { ClipboardList, FileSignature, Landmark, LayoutDashboard, Sun, Zap } from 'lucide-react';

export interface JoinStep {
  icon: typeof Sun;
  title: string;
  lines: string[];
  list?: string[];
}

export type JoinAudience = 'tous' | 'particulier';

export function joinSteps(t: TFunction, audience: JoinAudience = 'tous'): JoinStep[] {
  const particulier = audience === 'particulier';
  const k = (key: string) => t(`join.steps.${key}`);
  const platform = t('join.steps.platform', { returnObjects: true });
  return [
    { icon: ClipboardList, title: k('s1Title'), lines: particulier ? [k('s1Part1'), k('s1Part2')] : [k('s1All1'), k('s1All2')] },
    { icon: FileSignature, title: k('s2Title'), lines: [k('s2Line1'), k('s2Line2')] },
    { icon: Landmark, title: k('s3Title'), lines: particulier ? [k('s3Part')] : [k('s3AllPart'), k('s3AllEnt')] },
    { icon: Zap, title: k('s4Title'), lines: [k('s4Line')] },
    { icon: Sun, title: k('s5Title'), lines: [k('s5Line')] },
    { icon: LayoutDashboard, title: k('s6Title'), lines: [k('s6Line')], list: Array.isArray(platform) ? (platform as string[]) : [] },
  ];
}
